import React from 'react';
import { NeutralColors, DefaultPalette } from '@fluentui/react';
import {
  Button,
  makeStyles,
  TeachingPopover,
  TeachingPopoverBody,
  TeachingPopoverSurface,
  TeachingPopoverTitle,
  TeachingPopoverTrigger,
  TeachingPopoverFooter,
} from '@fluentui/react-components';
import { FluentIcon } from '@fluentui/react-icons';
import { TeachingPopoverProps } from '../../common/ActionButtons';

interface IMilestoneCardActionButtonProps {
  title: string;
  ariaLabel: string;
  iconProps: FluentIcon;
  disabled: boolean;
  isCurrent: boolean;
  teachingPopoverProps?: TeachingPopoverProps;
  onClick: (ev: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}
const useStyles = makeStyles({
  currentButton: {
    border: '1px solid transparent',
    marginLeft: '20px',
    color: DefaultPalette.blue,
    backgroundColor: NeutralColors.white,
    ':hover': {
      color: NeutralColors.white,
      backgroundColor: DefaultPalette.blue,
    },
  },
  defaultButton: {
    backgroundColor: NeutralColors.gray40,
  },
  disabledButton: {
    border: '1px solid transparent',
    marginLeft: '20px',
    color: NeutralColors.gray60,
  },
});

const MilestoneCardActionButton = (props: IMilestoneCardActionButtonProps): JSX.Element => {
  const { isCurrent, title, ariaLabel, iconProps, disabled, teachingPopoverProps, onClick } = props;
  const { header, content, showTeachingPopover, setShowTeachingPopover } =
    teachingPopoverProps || {};
  const styles = useStyles();

  const IconComponent = iconProps;
  return (
    <>
      {isCurrent && (
        <TeachingPopover
          open={showTeachingPopover}
          onOpenChange={(e, data) => {
            if (!data.open && setShowTeachingPopover) {
              setShowTeachingPopover(false);
            }
          }}
        >
          <TeachingPopoverTrigger>
            <Button
              id={title}
              title={title}
              aria-label={ariaLabel}
              icon={<IconComponent />}
              className={disabled ? styles.disabledButton : styles.currentButton}
              disabled={disabled}
              onClick={onClick}
            >
              {title}
            </Button>
          </TeachingPopoverTrigger>
          <TeachingPopoverSurface>
            <TeachingPopoverBody>
              <TeachingPopoverTitle>{header}</TeachingPopoverTitle>
              <div>{content}</div>
            </TeachingPopoverBody>
            <TeachingPopoverFooter primary="Close" />
          </TeachingPopoverSurface>
        </TeachingPopover>
      )}
      {!isCurrent && (
        <Button
          title={title}
          aria-label={ariaLabel}
          icon={<IconComponent />}
          className={styles.defaultButton}
          disabled={disabled}
          onClick={onClick}
        >
          {title}
        </Button>
      )}
    </>
  );
};
export default MilestoneCardActionButton;
